import React from 'react';

const LoadingSpinner = ({ size = 'default', message = 'Loading...' }) => {
  const sizeClasses = {
    small: 'h-6 w-6',
    default: 'h-12 w-12',
    large: 'h-16 w-16',
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-luxury-50 to-luxury-100">
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <div className={`animate-spin rounded-full border-4 border-primary-200 border-t-primary-600 ${sizeClasses[size]}`}></div>
        </div>
        <p className="text-luxury-600 font-medium">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner; 